import { render, staticRenderFns } from "./StackCollapseTransition.vue?vue&type=template&id=71aabc22&scoped=true"
import script from "./StackCollapseTransition.vue?vue&type=script&lang=js"
export * from "./StackCollapseTransition.vue?vue&type=script&lang=js"
import style0 from "./StackCollapseTransition.vue?vue&type=style&index=0&id=71aabc22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aabc22",
  null
  
)

export default component.exports